import { Action, Reducer, combineReducers } from "redux";
import { PayloadAction, createReducer } from "typesafe-actions";

import { swapViewAction } from "./views.actions";

export type ViewsApp = "Calls" | "Chats";

export interface Views {
  viewIsOpen: ViewsApp;
}

export const ViewsReducer: Reducer<Views> = combineReducers({
  viewIsOpen: createReducer<ViewsApp, Action>("Chats").handleAction(
    swapViewAction,
    (_: ViewsApp, { payload }: PayloadAction<string, ViewsApp>) => payload
  )
});
